<template><span hidden /></template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useState } from '#app'
import { eventOriginIsCapacitor } from '~/composables/mobile/verify-capacitor-event-origin'
import {
    useMobileInboxActions,
    type InboxNotification
} from '~/composables/mobile/inbox'

// Keep the listener below the app's organization provider so it shares the same authenticated context as CPX pages.
const { handleNotification, failedNotification } = useMobileInboxActions()
const activeNotificationId = useState<string | null>(
    'mobile-inbox-active-notification',
    () => null
)

/** Consume notification intents only from the native parent after its normal authentication handshake. */
function receiveNotification(event: MessageEvent) {
    if (!eventOriginIsCapacitor(event) || event.source !== window.parent) return
    if (
        event.data?.key !== 'INITIAL_NAVIGATION_MESSAGE_KEY' &&
        event.data?.key !== 'DEEP_LINK_MESSAGE_KEY'
    )
        return
    const notification = event.data.notification as
        | InboxNotification
        | undefined
    if (notification === undefined || notification === null) {
        // app.vue owns ordinary deep links; a slow inbox lookup must not replace that newer destination.
        activeNotificationId.value = null
        failedNotification.value = null
        return
    }
    if (
        typeof notification.clientEventId !== 'string' ||
        (notification.trackingReference !== null &&
            typeof notification.trackingReference !== 'string')
    )
        return
    failedNotification.value = null
    void handleNotification(
        notification,
        event.data.key === 'INITIAL_NAVIGATION_MESSAGE_KEY'
    )
}

onMounted(() => window.addEventListener('message', receiveNotification))
onUnmounted(() => window.removeEventListener('message', receiveNotification))
</script>
